import { capitalize } from "lodash";

export function getFirstCharacter(name?: string) {
    return capitalize(name && name.charAt(0));
  }